var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('br'),_c('h1',{staticStyle:{"color":"#594E42"}},[_vm._v("Under Construction")])])}]

export { render, staticRenderFns }